import {
  ActionReducer,
  ActionReducerMap,
  createReducer,
  on,
} from '@ngrx/store';
import {
  businessDataReducer,
  IBusinessAdditionalInfoProps,
  IBusinessDataAndGmbStatusState,
} from './business-config/business-config.reducer';
import * as fromBusinessConfigActions from './onboarding.actions';
import {
  IOnboardingRegistrationState,
  registrationDataReducer,
} from './registration/registration.reducer';

export interface OnboardingModulesState {
  userCreation: { completed: boolean };
  businessCreationInfo: { completed: boolean };
  businessAdditionalInfo: IBusinessAdditionalInfoProps;
}

export const initialModulesDataState: OnboardingModulesState = {
  userCreation: { completed: false },
  businessCreationInfo: { completed: false },
  businessAdditionalInfo: {
    services: { data: [], completed: false },
    schedule: { data: [], completed: false },
    paymentMethods: { data: [], completed: false },
    socialNetworks: {
      data: {
        facebook: '',
        twitter: '',
        instagram: '',
        tiktok: ''
      },
      completed: false,
    },
    gmbStatus: { data: { status: 'UNKNOWN' }, completed: false },
    notifications: {
      data: {
        email: false,
        sms: false,
        push: false,
        clients: false,
        generals: false,
        products: false,
      },
      completed: false,
    },
    website: {
      data: {
        type: 'new',
        images: {
          logoImage: null,
          bannerImage: null,
          productsImage: [],
          mainImage: null,
          contactImage: null,
          spotlightImage: null,
        },
        // eslint-disable-next-line @typescript-eslint/naming-convention
        business_id: null,
        description: '',
        //shortDescription: string;
        /* showSchedule: false,
        showServices: false,
        showSocialNetworks: false, */
      },
      completed: false,
    },
    moduleConcluded: false,
  },
};

export const modulesDataReducer: ActionReducer<OnboardingModulesState> =
  createReducer(
    initialModulesDataState,

    // PREFILL DATA - ACTIONS
    on(
      fromBusinessConfigActions.prefillServicesDataAction,
      (state, { payload }): OnboardingModulesState => ({
        ...state,
        businessAdditionalInfo: {
          ...state.businessAdditionalInfo,
          services: {
            ...state.businessAdditionalInfo.services,
            data: [...payload],
          },
        },
      })
    ),
    on(
      fromBusinessConfigActions.prefillScheduleDataAction,
      (state, { payload }): OnboardingModulesState => ({
        ...state,
        businessAdditionalInfo: {
          ...state.businessAdditionalInfo,
          schedule: {
            ...state.businessAdditionalInfo.schedule,
            data: [...payload],
          },
        },
      })
    ),

    on(
      fromBusinessConfigActions.setServicesCompletedAction,
      (state, { payload }): OnboardingModulesState => ({
        ...state,
        businessAdditionalInfo: {
          ...state.businessAdditionalInfo,
          services: {
            data: payload,
            completed: true,
          },
        },
      })
    ),
    on(
      fromBusinessConfigActions.setScheduleCompletedAction,
      (state, { payload }): OnboardingModulesState => ({
        ...state,
        businessAdditionalInfo: {
          ...state.businessAdditionalInfo,
          schedule: {
            data: payload,
            completed: true,
          },
        },
      })
    ),
    on(
      fromBusinessConfigActions.setPaymentMethodsCompletedAction,
      (state, { payload }): OnboardingModulesState => ({
        ...state,
        businessAdditionalInfo: {
          ...state.businessAdditionalInfo,
          paymentMethods: {
            data: payload,
            completed: true,
          },
        },
      })
    ),
    on(
      fromBusinessConfigActions.setSocialNetworksCompletedAction,
      (state, { payload }): OnboardingModulesState => ({
        ...state,
        businessAdditionalInfo: {
          ...state.businessAdditionalInfo,
          socialNetworks: { data: payload, completed: true },
        },
      })
    ),
    on(
      fromBusinessConfigActions.setGmbStatusCompletedAction,
      (state, { payload }): OnboardingModulesState => ({
        ...state,
        businessAdditionalInfo: {
          ...state.businessAdditionalInfo,
          gmbStatus: { data: payload, completed: true },
        },
      })
    ),
    on(
      fromBusinessConfigActions.setNotificationsCompletedAction,
      (state, { payload }): OnboardingModulesState => ({
        ...state,
        businessAdditionalInfo: {
          ...state.businessAdditionalInfo,
          notifications: { data: payload, completed: true },
        },
      })
    ),
    on(
      fromBusinessConfigActions.setWebsiteCompletedAction,
      (state, { payload }): OnboardingModulesState => ({
        ...state,
        businessAdditionalInfo: {
          ...state.businessAdditionalInfo,
          website: { data: payload, completed: true },
          moduleConcluded: true,
        },
      })
    )
  );

export interface IOnboardingState {
  registrationState: IOnboardingRegistrationState;
  businessDataAndGmbStatusState: IBusinessDataAndGmbStatusState;
  modulesDataState: OnboardingModulesState;
}

export const onboardingReducer: ActionReducerMap<IOnboardingState> = {
  registrationState: registrationDataReducer,
  businessDataAndGmbStatusState: businessDataReducer,
  modulesDataState: modulesDataReducer,
};
